import axios from "axios";
import { toast } from "react-toastify";
import { PointsSettings } from "../models/PointsSettings";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Récupère les paramètres des points
 */
export const getPointsSettings = async (): Promise<PointsSettings> => {
  try {
    const response = await axios.get<PointsSettings>(`${API_URL}/points-settings`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    toast.error("Erreur lors de la récupération des paramètres points");
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error("Erreur inconnue");
    }
  }
};

/**
 * Sauvegarde la configuration des points
 */
export const createPointsSettings = async (
  multiplier: number,
  pointValue: number
): Promise<PointsSettings> => {
  try {
    const response = await axios.post<PointsSettings>(
      `${API_URL}/points-settings`,
      { multiplier, pointValue },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );
    toast.success("Paramètres enregistrés avec succès !");
    return response.data;
  } catch (error) {
    toast.error("Erreur lors de la sauvegarde des paramètres points");
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error("Erreur inconnue");
    }
  }
};
